import { cn } from "@/lib/utils";

interface TrustedByProps {
  className?: string;
  title?: string;
  logos?: {
    src: string;
    alt: string;
    width: number;
    height: number;
  }[];
}

const TrustedBy = ({
  className,
  title = "Some innovative companies we've worked with",
  logos = [
    {
      src: "/lovable-uploads/20ae4e93-9de1-4ed7-99c5-2664cefacfe4.png",
      alt: "Tokyo Brand House Creative",
      width: 160,
      height: 40,
    },
    {
      src: "/lovable-uploads/d36f1b48-5a6a-4bf9-abaa-8f0ca413dba4.png",
      alt: "Handy Cats",
      width: 120,
      height: 40,
    },
    {
      src: "/lovable-uploads/cb90f79c-d7f6-4170-9435-5758a58d9759.png",
      alt: "Pangolin Photo Safaris",
      width: 150,
      height: 40,
    },
    {
      src: "/lovable-uploads/dcebdb28-9b84-43b7-86f1-b182477d9d72.png",
      alt: "Business Panda",
      width: 140,
      height: 40,
    },
    {
      src: "/lovable-uploads/327c685e-0a95-438d-8a5f-5eb0e0645f40.png",
      alt: "The Frame Room",
      width: 160,
      height: 40,
    },
  ],
}: TrustedByProps) => {
  return (
    <div className={cn("w-full py-12 md:py-16 bg-muted/50 backdrop-blur-sm", className)}>
      <div className="container max-w-7xl mx-auto px-4 md:px-6">
        <p className="text-center text-sm font-medium text-muted-foreground mb-8 md:mb-10">{title}</p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12 items-center justify-items-center">
          {logos.map((logo, index) => (
            <div 
              key={index} 
              className="w-full flex items-center justify-center opacity-80 hover:opacity-100 transition-opacity"
            >
              <img 
                src={logo.src} 
                alt={logo.alt}
                width={logo.width}
                height={logo.height}
                className="h-8 w-auto"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedBy;
